var Event = require('./event.js')

module.exports = Source

function Source(broadcaster) {
    var tuple = Event()

    broadcaster(tuple.broadcast)

    return tuple.listen
}



//////////////////
// WEBPACK FOOTER
// ./~/geval/source.js
// module id = 135
// module chunks = 0